package io.horion.cv.api.datasource.job

import kotlinx.serialization.Serializable

@Serializable
enum class ExperienceLevel {
    JUNIOR, MID, SENIOR, EXPERT
}